// extracted by mini-css-extract-plugin
module.exports = {"totalInclAmount":"AddInvoicePopup_totalInclAmount__duQaJ","documentContainer":"AddInvoicePopup_documentContainer__32CMc"};